import { CheckCircle, AlertTriangle, XCircle, Clock, Loader2, MinusCircle } from 'lucide-react';
import { MODULE_DISPLAY_NAMES, type ModuleRun, type ModuleStatus } from '@/types/forensics';

const STATUS_ICON: Record<ModuleStatus, React.ReactNode> = {
  pending: <Clock className="h-4 w-4 text-muted-foreground" />,
  running: <Loader2 className="h-4 w-4 text-blue-500 animate-spin" />,
  success: <CheckCircle className="h-4 w-4 text-green-500" />,
  warning: <AlertTriangle className="h-4 w-4 text-orange-500" />,
  failed: <XCircle className="h-4 w-4 text-red-500" />,
  skipped: <MinusCircle className="h-4 w-4 text-gray-400" />,
};

interface ModuleProgressListProps {
  moduleRuns: ModuleRun[];
}

export default function ModuleProgressList({ moduleRuns }: ModuleProgressListProps) {
  if (moduleRuns.length === 0) {
    return <p className="text-sm text-muted-foreground">Waiting for modules to start...</p>;
  }

  return (
    <div className="space-y-1">
      {moduleRuns.map((run) => (
        <div key={run.id} className="flex items-center gap-2 py-1.5 px-2 rounded hover:bg-muted/50">
          {STATUS_ICON[run.status]}
          <span className="text-sm flex-1">{MODULE_DISPLAY_NAMES[run.moduleName] || run.moduleName}</span>
          {run.runtimeMs != null && <span className="text-xs text-muted-foreground">{(run.runtimeMs / 1000).toFixed(1)}s</span>}
        </div>
      ))}
    </div>
  );
}
